import { Auth0Provider, AppState } from '@auth0/auth0-react';
import React from 'react';
import { useNavigate } from 'react-router-dom';

interface Auth0ProviderWithNavigateProps {
  children: React.ReactNode;
}

const domain = import.meta.env.VITE_AUTH0_DOMAIN ?? '';
const clientId = import.meta.env.VITE_AUTH0_CLIENT_ID ?? '';
const redirectUri = import.meta.env.VITE_AUTH0_CALLBACK_URL ?? '';
const audience = import.meta.env.VITE_AUTH0_AUDIENCE ?? '';

export const Auth0ProviderWithNavigate = ({ children }: Auth0ProviderWithNavigateProps) => {
  const navigate = useNavigate();

  const onRedirectCallback = (appState?: AppState) => {
    const returnTo = appState?.returnTo ?? '/';
    navigate(returnTo);
  };

  if (!(domain && clientId && redirectUri && audience)) {
    return null;
  }

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      useRefreshTokens={true}
      cacheLocation="localstorage"
      authorizationParams={{
        audience: audience,
        redirect_uri: redirectUri,
        scope: 'openid profile email offline_access'
      }}
      onRedirectCallback={onRedirectCallback}>
      {children}
    </Auth0Provider>
  );
};
